import { render } from "./AuraComposer.vue?vue&type=template&id=3e3969f5&scoped=true&ts=true"
import script from "./AuraComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraComposer.vue?vue&type=script&setup=true&lang=ts"

import "./AuraComposer.vue?vue&type=style&index=0&id=3e3969f5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3969f5"],['__file',"src/views/pages/aura/components/AuraComposer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e3969f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e3969f5', __exports__)) {
    api.reload('3e3969f5', __exports__)
  }
  
  module.hot.accept("./AuraComposer.vue?vue&type=template&id=3e3969f5&scoped=true&ts=true", () => {
    api.rerender('3e3969f5', render)
  })

}


export default __exports__